import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: '[templateName]' })
export class TemplateNameDirective {
  @Input('templateName') name!: string;

  constructor(public templateRef: TemplateRef<any>) {}
}
